import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { resetQueries } from '@/utils'
import { getApiErrorMessage } from '@/utils/error'

import { GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY } from './get-checklist-task-details'
import { GET_CHECKLISTS_BASE_QUERY_KEY } from './get-checklists'

interface ApproveChecklistRequest {
  checklistId: number
}

export const approveChecklist = async (data: ApproveChecklistRequest) => {
  const response = await authAPI.post(`/checklist-unified/${data.checklistId}/approve`)
  return response.data
}

export const useApproveChecklist = () => {
  return useMutation({
    mutationFn: approveChecklist,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async () => {
      await resetQueries(
        [GET_CHECKLISTS_BASE_QUERY_KEY],
        [GET_CHECKLIST_TASK_DETAILS_BASE_QUERY_KEY],
      )
      toastFactory.success('Checklist approved successfully')
    },
  })
}
